import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order?: {
    status?: string;
  };
};

const OrderStatusCell = React.memo((row: KpiWorkunitGridData) => {
  const statusName = row?.order?.status ?? '-';

  return (
    <>
      {statusName && (
        <Tooltip title={statusName}>
          <Typography variant="body2" noWrap>
            {statusName}
          </Typography>
        </Tooltip>
      )}
    </>
  );
});

export default OrderStatusCell;
